import axios from "axios";
import { toast } from "react-toastify";

// 로그인
// 방식 : POST
// Login.jsx 참조

// 고객정보
// 방식 : POST
export const getClientInfo = async (
  Server_IP,
  token,
  clientCode,
  setClientInfo
) => {
  try {
    const { data } = await axios.post(
      `${Server_IP}/api/getClientInfo/`,
      { clientCode },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setClientInfo(data);
  } catch (error) {
    console.log(error);
  }
};

// 주문대장 조회
// 방식 : POST
export const getOrderBook = async (
  Server_IP,
  token,
  clientCode,
  queryYear,
  setOrderBookList
) => {
  try {
    const { data } = await axios.post(
      `${Server_IP}/api/getOrderBook/`,
      { clientCode, queryYear },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setOrderBookList(data);
  } catch (error) {
    console.log(error);
  }
};

// 주문대장 추가
// 방식 : POST
export const addOrderBook = (
  e,
  Server_IP,
  token,
  data,
  setOrderBookList,
  callback
) => {
  e.preventDefault();
  axios
    .post(`${Server_IP}/api/addOrderBook/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (typeof setOrderBookList === "function") {
        setOrderBookList((prev) => [...prev, response.data]);
      }
      if (callback) callback(response.data);
    })
    .catch((error) => {
      console.error("OrderBook 추가 중 오류:", error);
    });
};

// 주문대장(ORDER_BOOK) 삭제
// 방식 : DELETE
export const deleteOrderBook = async (
  id,
  Server_IP,
  token,
  reloadOrderBook,
  orderBookReset
) => {
  try {
    const response = await axios.delete(
      `${Server_IP}/api/deleteOrderBook/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      await reloadOrderBook(); // ✅ 이걸 추가해야 getOrderBook이 실행됨
      orderBookReset();
      return true;
    }
    toast.error("주문번호 삭제 실패: " + response.status);
    return false;
  } catch (error) {
    console.error("주문번호 삭제 중 오류 발생:", error);
    toast.error("주문번호 삭제 중 오류가 발생했습니다.");
    return false;
  }
};

// 고객 품목 리스트 조회
// 방식 : POST
export const getClientItemList = async (
  Server_IP,
  token,
  clientCode,
  setClientItemList
) => {
  try {
    const { data } = await axios.post(
      `${Server_IP}/api/getClientItemList/`,
      { clientCode },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setClientItemList(data);
  } catch (error) {
    console.log(error);
  }
};

// 로그인 시 활성 공지사항 조회
export const getOutboundNoticeList = async (Server_IP, token) => {
  try {
    const { data } = await axios.get(`${Server_IP}/api/getOutboundNotify`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getOutboundNoticeManageList = async (Server_IP, token) => {
  try {
    const { data } = await axios.get(
      `${Server_IP}/api/getOutboundNotifyManage`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const addOutboundNotice = async (Server_IP, token, payload) => {
  try {
    const { data } = await axios.post(
      `${Server_IP}/api/addOutboundNotify`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateOutboundNotice = async (Server_IP, token, payload) => {
  try {
    const { data } = await axios.post(
      `${Server_IP}/api/updateOutboundNotify`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteOutboundNotice = async (Server_IP, token, seq) => {
  try {
    const { data } = await axios.delete(
      `${Server_IP}/api/deleteOutboundNotify/${seq}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// 공지 이미지 업로드 (FormData)
export const uploadOutboundNotifyImage = async (Server_IP, token, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axios.post(
      `${Server_IP}/api/uploadOutboundNotifyImage`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return data;
  } catch (error) {
    console.error("공지 이미지 업로드 실패:", error);
    return null;
  }
};



//  공급형태코드를 고객정보로부터 얻기
// 방식 : POST
export const getSupplyTypeCode = async (
  Server_IP,
  token,
  clientCode
) => {
  try {
    const { data } = await axios.post(
      `${Server_IP}/api/getSupplyTypeCode/`,
      { clientCode },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

     return data;

  } catch (error) {
    console.log(error);
    return null;
  }
};


export const addOrderItem = async (
  Server_IP,
  token,
  orderItemData,
  setOrderItemList,
  callback
) => {
  try {
    const response = await axios.post(
      `${Server_IP}/api/addOrderItem/`,
      orderItemData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (typeof setOrderItemList === "function") {
      setOrderItemList((prevList) => [...prevList, response.data]);
    }

    if (callback) callback(response.data); // 추가 작업을 위한 콜백 호출
  } catch (error) {
    console.error("OrderItem 추가 중 오류:", error);
    toast.error("주문 아이템 추가에 실패했습니다. 다시 시도해주세요.");
  }
};

export const updateOrderItem = async (
  Server_IP,
  token,
  orderItemData,
  setOrderItemList,
  callback
) => {
  try {
    const response = await axios.post(
      `${Server_IP}/api/updateOrderItem/`,
      orderItemData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const updatedItem = response.data; // 서버에서 반환한 최신 데이터

    if (typeof setOrderItemList === "function") {
      setOrderItemList((prevList) =>
        prevList.map((item) =>
          item.ProductCode === updatedItem.ProductCode ? updatedItem : item
        )
      );
    }

    if (callback) callback(updatedItem); // 추가 작업을 위한 콜백 호출
  } catch (error) {
    console.error("OrderItem 수정 중 오류:", error);
    toast.error("주문 아이템 수정에 실패했습니다. 다시 시도해주세요.");
  }
};

/*********************************************************************
// 일련번호 : 7
// 제   목 : 주문품목(ORDER_ITEMS) 조회
// 방   식 : POST 
// 요청필드 : ① OBserial
// 응답필드 : ① Json Data {ClientName, ClientCode, DeputyName, BusinessNo, DeliveryAddr, Tel, Fax, Email }
// 응답코드 : ① 200 ② 404 ③ 500
**********************************************************************/
export const showOrderItemList = async (
  Server_IP,
  token,
  OBserial,
  setOrderItem
) => {
  try {
    if (!OBserial) {
      console.warn("OBserial이 유효하지 않아 요청을 생략합니다.");
      setOrderItem([]); // 빈 배열 또는 null로 초기화
      return;
    }

    const { data } = await axios.post(
      `${Server_IP}/api/getOrderItemsByOBserial/`,
      { OBserial },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setOrderItem(data);
    return data;
  } catch (error) {
    console.error(
      "주문 아이템 불러오기 실패:",
      error?.response?.data?.error || error.message
    );
    setOrderItem([]); // 실패 시에도 초기화하여 안전하게 처리
    return null;
  }
};
// 주문품목 삭제
export const deleteOrderItem = async (
  OIserial,
  Server_IP,
  token,
  refreshOrderItem,
  onResetOrderItem
) => {
  try {
    const response = await axios.delete(
      `${Server_IP}/api/deleteOrderItemsByOIserial/${OIserial}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      await refreshOrderItem();
      onResetOrderItem();
      return true;
    }
    return false;
  } catch (error) {
    console.error("주문 아이템 삭제 실패:", error);
    return false;
  }
};

// OBserial 얻기
export const getOBserial = async (Server_IP, token, clientCode) => {
  try {
    const response = await axios.post(
      `${Server_IP}/api/getSerial`,
      { prefix: "OB", tableName: "ORDER_BOOK", fieldName: "OBserial" },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data.newSerial; // OBserial을 반환합니다.
    } else {
      toast.error("시리얼 요청 실패: " + response.status);
      return null;
    }
  } catch (error) {
    console.log(error);
    toast.error("OBserial 시리얼 번호 요청 중 오류 발생");
  }
};

// OIserial 얻기
export const getOIserial = async (Server_IP, token, obserial) => {
  try {
    const response = await axios.post(
      `${Server_IP}/api/getSerial`,
      { prefix: "OI", tableName: "ORDER_ITEMS", fieldName: "OIserial" },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data.newSerial;
    } else {
      toast.error("시리얼 요청 실패: " + response.status);
      return null;
    }
  } catch (error) {
    console.error("getOIserial 오류:", error);
    toast.error("OIserial 시리얼 번호 요청 중 오류 발생");
    return null;
  }
};

// 요구사항 저장
export const updateClientRequest = async (
  Server_IP,
  token,
  requestText,
  obserial
) => {
  try {
    const response = await axios.post(
      `${Server_IP}/api/updateClientRequest`,
      { requestText, obserial },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      return true;
    } else {
      toast.error("고객요구사항 저장 실패: " + response.status);
      return false;
    }
  } catch (error) {
    toast.error("고객요구사항 저장 중 오류 발생");
    return false; // 또는 throw error
  }
};

// OrderStatus 저장 - 주문확인 등등
export const updateFieldTable = async (
  Server_IP,
  token,
  tableName,
  whereFieldName,
  whereFieldValue,
  updateFieldName,
  updateValue
) => {
  try {
    const response = await axios.post(
      `${Server_IP}/api/updateFieldTable`,
      {
        tableName,
        whereFieldName,
        whereFieldValue,
        updateFieldName,
        updateValue,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      return true;
    } else {
      toast.error("Update에러: " + response.status);
      return false;
    }
  } catch (error) {
    toast.error("Update 중 오류 발생");
    return false; // 또는 throw error
  }
};

export const fetchUpdatedRow = async (
  Server_IP,
  token,
  tableName,
  fieldName,
  rowIdValue
) => {
  const res = await axios.post(
    `${Server_IP}/api/fetchUpdatedRow`,
    {
      tableName,
      fieldName,
      rowIdValue,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

export const sendChatMessage = async (Server_IP, token, message) => {
  try {
   
    const response = await axios.post(
      `${Server_IP}/api/sendToSynologyChat`,
      {
        message,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json', // (권장) 명시적 설정
        },
      }
    );
    if (response.status === 200) {
      return true;
    } else {
      toast.error(
        response.data?.message || `Chat 메시지 전송 실패: ${response.status}`,
      );
      return false;
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Chat 메시지 전송 중 오류 발생",
    );
    return false; // 또는 throw error
  }
};
